module.exports = __webpack_public_path__ + "static/media/Human_ZG8447_1440.726f4a00.jpg";